/* =================== HEADER FULL =================== */
jQuery(document).ready(function($){
  const header = $('.header-full');
  if (header.length > 0) {
    function toggleHeaderFull() {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > 100) {
        header.addClass('active');
      } else {
        header.removeClass('active');
      }
    }
    toggleHeaderFull();
    $(window).on('scroll', debounce(function(){
      toggleHeaderFull();        
    }, 10));
  }
});



/* =================== MENU DESKTOP =================== */
// Fixa o menu ao dar scroll na página
jQuery(document).ready(function ($) {
  // Exibe / Oculta busca
  $('.open-busca').on('click', function(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      $('.header-busca').toggleClass('active');
      if ($('.header-busca').hasClass('active')) {
          //$('.header-busca #busca').focus();
      }
  });

  // Impede que a busca seja ocultada ao clicar sobre a mesma
  $('.header-busca').on('click', function(ev) {
      ev.stopPropagation();
  });

  // Oculta a busca quando clicar em qualquer parte da tela
  $('body').on('click', function(ev) {
     //$('.header-busca').removeClass('active');
  });
}); 


(function () {
  "use strict";

  const $btnToggleBusca = $(".busca-toggle a");
  const $busca = $(".header-busca-mobile");
  const $buscaInput = $busca.find("input");

  $btnToggleBusca.on("click", function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    if ($busca.hasClass("active")) {
      hideBusca();
    } else {
      showBusca();
    }
  });
  $busca.on("click", function (ev) {
    ev.stopPropagation();
  });

  $("body").on("click", function (ev) {
    hideBusca();
  });

  // Fecha a busca ao pressionar a tecla ESC
  $(document).on("keyup", function (e) {
    if (e.keyCode == 27) {
      hideBusca();
    }
  });

  function showBusca() {
    $busca.addClass("active");
    setTimeout(() => {
      $buscaInput.focus();
    }, 100);
  }

  function hideBusca() {
    $busca.removeClass("active");
    $buscaInput.val("");
  }
})();
